// These keys map directly to hidden input fields from Marketo forms (or custom forms).
// Purpose of these are to derive state to return as values to the form as hidden input field data.

export const relativeURL = (vm) => vm.$route?.path

export const mkto_webinarStage = () => ({past: 'on-demand', intermediate: 'waitlist', future: 'live'}[document.querySelector('[data-time-state]').dataset.timeState]) || ''
